// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'iview'
import ElementUI from 'element-ui';

import axios from 'axios'
import VueCookies from 'vue-cookies'

import 'babel-polyfill'

import App from './App'
import router from './router'

import 'element-ui/lib/theme-chalk/index.css';
import 'iview/dist/styles/iview.css';
import './css/style.css'
import 'font-awesome/css/font-awesome.min.css'
import mui from 'vue-awesome-mui';


Vue.config.productionTip = false
localStorage.removeItem('userInfo')
Vue.use(iView)
Vue.use(VueCookies)
Vue.use(mui)
Vue.use(ElementUI);

Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js